import Api from "~/service/Api";

class PhotoEditingPhotoRepository {
  batchDelete(photoEditingPhotosIds) {
    // this format is compatible with php's http_build_query when dealing with arrays.
    const params = photoEditingPhotosIds.map(id => `ids[]=${id}`);
    const query = params.join("&");

    return Api.delete(`/photo-editing/photos?${query}`);
  }
}

export default PhotoEditingPhotoRepository;
